// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2PNPl","search":"Settings_search__1eC0G","filter":"Settings_filter__135N4"};